<script setup>
import { useAttrs, computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

const attrs = useAttrs();
const globalConfig = useMapGetter('globalConfig/get');

// Construct path dynamically to prevent Vite from trying to resolve it as a module
const defaultLogo = computed(() => {
  if (globalConfig.logoThumbnail) {
    return globalConfig.logoThumbnail;
  }
  // Use a dynamic path construction to avoid Vite processing it
  const parts = ['', 'letel-icon-32x32.png'];
  return parts.join('/');
});
</script>

<template>
  <img
    v-bind="attrs"
    :src="defaultLogo"
    alt="Talk Letel"
  />
</template>
